import { isCraneManagerHostAllowed, isCraneManagerPath } from '../utils/craneManagerPaths'
import { resolveCraneManagerHostname } from '~~/layers/base/utils/normalizeHostname'

/**
 * Client-side refuse for SPA navigations when the designer/CM hostname is unset
 * or wrong. Access JWT is enforced only on the server (secrets are server-only).
 *
 * Local (`appEnvId=local` or a `nuxt dev` server): allow SPA navigation for DX;
 * APIs still need `NUXT_CRANE_MANAGER_ACCESS_DEV_BYPASS=1` on the server.
 */
export default defineNuxtRouteMiddleware((to) => {
    if (!isCraneManagerPath(to.path)) {
        return
    }
    if (!import.meta.client) {
        return
    }

    const config = useRuntimeConfig()
    const appEnvId = String(config.public.appEnvId || '')
    if (appEnvId === 'local' || import.meta.dev) {
        return
    }

    const staffHostname = resolveCraneManagerHostname(
        config.public.craneManagerHostname,
        config.public.designerBaseUrl
    )
    if (!staffHostname || !isCraneManagerHostAllowed(window.location.hostname, staffHostname)) {
        return abortNavigation(
            createError({
                statusCode: 404,
                statusMessage: 'Not Found',
            })
        )
    }
})
